import { render, staticRenderFns } from "./canteenAmountRecord.vue?vue&type=template&id=d4bf53da&scoped=true"
import script from "./canteenAmountRecord.vue?vue&type=script&lang=js"
export * from "./canteenAmountRecord.vue?vue&type=script&lang=js"
import style0 from "./canteenAmountRecord.vue?vue&type=style&index=0&id=d4bf53da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bf53da",
  null
  
)

export default component.exports